export default {
    tokens: {
        'generate-token': 'Generate token',
        list: {
            title: 'Organization tokens',
            'search-by-name': 'Search by name',
            empty: {
                title: 'No tokens found',
                message: 'Add an organization token or check the search filter.',
            },
            headers: {
                name: 'Name',
                description: 'Description',
                createdAt: 'Created at',
                expiresAt: 'Expires at',
                revokedAt: 'Revoked at',
                createdBy: 'Created by',
                status: 'Status',
                role: 'Role',
            },
            actions: {
                revoke: 'Revoke token',
            },
        },
        revoke: {
            confirm: {
                title: 'Revoke token',
                description: 'Are you sure you want to revoke token "{name}"? This action cannot be undone.',
            },
            success: 'Token "{name}" has been revoked',
        },
        'create-modal': {
            title: 'Generate new organization token',
            success: 'Token "{name}" has been created',
            label: {
                name: 'Name',
                description: 'Description',
                expiresAt: 'Expires at',
                workspace: 'Workspace',
                role: 'Workspace role',
                'generate-token': 'Generate token',
            },
        },
        'generated-token': {
            title: 'Organization token',
            info: 'Make sure to copy your organization token now. You won\'t be able to see it again!',
            description: 'Description',
            copied: 'Token "{name}" has been copied to clipboard.',
            button: {
                close: 'Copy and close',
            },
        },
        'token-details': {
            details: 'Details',
            status: 'Status',
            'token-id': 'Token ID',
            'organization-id': 'Organization ID',
            workspace: 'Workspace',
            'workspace-type': 'Workspace type',
            role: 'Role: {name}',
            name: 'Name',
            permissions: 'Permissions',
            at: 'at',
            id: 'ID',
            'created-by': 'Created by',
            'revoked-by': 'Revoked by',
            'expires-at': 'Expires at',
            'expired-at': 'Expired at',
            description: 'Description',
            'permissions-table': {
                'resource-type': 'Resource type',
                relation: 'Relation',
                'resource-id': 'Resource ID',
            },
        },
    },
}
